// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__28NJA","subheader":"ReorderModal_subheader__ebL5L","listWrap":"ReorderModal_listWrap__2QLCX"};